import axios from "axios";
import { baseApiUrl } from "src/utils/baseurl";

const customerAPI = axios.create({
  baseURL: baseApiUrl,
  headers: {'Content-Type': "application/json"},
});

export default customerAPI;